import { HAMBURGER_MENU_ID } from '../header/utils/constants';
import { MYKBB_MENU_ID } from '../mykbb/utils/constants';
export function resetMenus(withMyKbb) {
  const menus = withMyKbb ? [HAMBURGER_MENU_ID, MYKBB_MENU_ID] : [HAMBURGER_MENU_ID];
  menus.forEach(menu => {
    if (document.getElementById(menu) && document.getElementById(menu).checked) {
      document.getElementById(menu).checked = false;
    }
  });
}
export function openMenu(menu) {
  if (!!menu) {
    menu.checked = true;
  }
}
export function setFixedBody(isMenuOpen) {
  const body = document.body;
  if (isMenuOpen) {
    body.classList.add('with-menu-open');
  } else {
    body.classList.remove('with-menu-open');
  }
}